export const CELSIUS = 'CELSIUS'
export const FAHRENHEIT = 'FAHRENHEIT'

export default {
  CELSIUS,
  FAHRENHEIT,
}
